import ConfirmModal from "PFComponents/confirm/confirm_modal";
import Toggle from "PFComponents/toggle/toggle";
import { getProfileName, isAdmin, isSaasAdmin } from "PFCore/helpers/profile";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { useErrorsGrowl } from "PFCore/hooks/use_errors_growl";
import { toggleUserStatus } from "PFCore/services/admin/users/toggle_user_status";
import PropTypes from "prop-types";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

const canChange = (user, currentUserIsSaasAdmin) => {
  if (isAdmin(user, true)) {
    return false; // saas_admins cannot be suspended
  } else if (currentUserIsSaasAdmin) {
    return true;
  } else if (isAdmin(user)) {
    return false; // Only saas admin can suspend admins
  }
  return true;
};

const SuspendAction = ({ user, refetchUsers }) => {
  const { t } = useTranslation("admin", { keyPrefix: "users.list.actions" });

  const { data: currentProfile } = useCurrentProfile();
  const growlErrors = useErrorsGrowl();

  const [showModal, setShowModal] = useState(false);

  const isActive = !user.suspended;

  const handleToggleSuspend = useCallback(() => {
    if (isActive) {
      setShowModal(true);
    } else {
      toggleStatus();
    }
  }, [user, isActive]);

  const toggleStatus = () => {
    toggleUserStatus(user.id, isActive).then(refetchUsers, (response) => growlErrors(response));
  };

  return (
    <>
      <Toggle
        qaId={`AdminActionButton.suspend.${isActive ? "isActive" : "isSuspended"}`}
        onChange={handleToggleSuspend}
        checked={!isActive}
        disabled={!canChange(user, isSaasAdmin(currentProfile))}
        inline
      />

      {showModal && (
        <ConfirmModal handleOK={toggleStatus} handleClose={() => setShowModal(false)}>
          {t("suspendConfirm", { name: getProfileName(user) })}
        </ConfirmModal>
      )}
    </>
  );
};

SuspendAction.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    suspended: PropTypes.bool,
    roles: PropTypes.array
  }),

  refetchUsers: PropTypes.func
};

export default SuspendAction;
